import React from 'react';

import { AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

import { type CardSizes } from '@pkg/components';
import { NFTAsset } from '@pkg/components/Sections/Groups/GroupCard';

import { type CollectionChainType, SupportedTokens } from '@app/client';

import { Rarity, RarityText, Wrapper } from './styles';

interface CardMediaProps {
    image_url?: string | null;
    animation_url?: string | null;
    fallback?: string | null;
    contract?: string | null;
    shadow?: boolean;
    token_id?: string | null;
    rarity_rank?: number | null;
    cardSize?: CardSizes;
    chain?: CollectionChainType;
    objectFit?: 'cover' | 'contain';
    isHovering?: boolean;
}

export const CardMedia = ({
    image_url,
    animation_url,
    fallback,
    contract,
    token_id,
    objectFit = 'contain',
    shadow,
    chain,
    rarity_rank,
    cardSize,
    isHovering,
}: CardMediaProps) => {
    const linkDisabled = !chain || !contract || !token_id;
    const markup = (
        <Wrapper $shadow={shadow} $disabled={linkDisabled}>
            <AnimatePresence>
                {rarity_rank && !isHovering ? (
                    <Rarity
                        $cardSize={cardSize}
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.8 }}
                    >
                        <RarityText>
                            {cardSize !== 'small' && 'Rank '}#{rarity_rank}
                        </RarityText>
                    </Rarity>
                ) : null}
            </AnimatePresence>
            <NFTAsset
                imageUrl={image_url || undefined}
                videoUrl={animation_url || undefined}
                fallback={fallback || undefined}
                objectFit={objectFit}
            />
        </Wrapper>
    );

    // TODO: Remove this once we support multichain collections page
    if (linkDisabled) {
        return markup;
    }

    return <Link to={`/collectible/${SupportedTokens[chain]}/${contract}/${token_id}?goBack=1`}>{markup}</Link>;
};
